import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../app-core/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class RoleGuard {
    private readonly notificationService = inject(NotificationService);
    private readonly translate = inject(TranslateService);
    private readonly authService = inject(AuthService);


    canActivate(): Observable<boolean> {
        return this.authService.isAdmin()
            .pipe(
                tap(p => p || this.notificationService.showMsg(this.translate.instant('route.noPermission'), 'error'))
            );
    }
}
